export default __webpack_public_path__ + "static/media/example-art.9dd8f44a.jpg";